export default __webpack_public_path__ + "static/media/pike13-cancel-reschedule.96eeae4a.png";